/* eslint-disable @typescript-eslint/no-unused-vars */
import { FeaturesFlags } from "helpers";
import { Fragment, useState } from "react";
import ClubEventSection from "./ClubEventSection";
import { useEnvContext } from "contexts/EnvProvider";
import { PageContent } from "components/PageContent";
import { GiftBoxesSection } from "./GiftBoxesSection/index";
import { useWebStoreContext } from "../../contexts/WebStoreProvider";
import PageTopNav, { ISectionMenuItem } from "../../components/PageTopNav";
import PageTopNavV2 from "../../components/PageTopNavV2";
import ClubEventSectionV2 from "./ClubEventSectionV2";
import { PrivateRoute } from "routes/PrivateRoute";
//import ClubEventSectionV2 from "./ClubEventSectionV2";

const ClubShop = () => {
	const { userTracker } = useWebStoreContext();
	const [sectionMenuData] = useState<ISectionMenuItem[]>([]);
	const { isFeatureFlagEnabled } = useEnvContext();

	return (
		<PrivateRoute
			isEnabled={
				(userTracker?.clubId ? true : false) &&
				isFeatureFlagEnabled(FeaturesFlags.CLUB_SHOP)
			}
		>
			<Fragment>
				{isFeatureFlagEnabled(FeaturesFlags.UI_V2) ? (
					<PageTopNavV2 sectionMenuData={sectionMenuData} />
				) : (
					<PageTopNav sectionMenuData={sectionMenuData} />
				)}
				<PageContent source="club_shop_page">
					{isFeatureFlagEnabled(FeaturesFlags.CLUB_GIFT_BONUS) && (
						<ClubEventSectionV2 />
					)}
					<GiftBoxesSection />
				</PageContent>
			</Fragment>
		</PrivateRoute>
	);
};

export default ClubShop;
